export const styles = {
  tableRow: {
    height: '2.75rem',
  },
};
